import { render, staticRenderFns } from "./NavList.vue?vue&type=template&id=6645b1b0&"
import script from "./NavList.vue?vue&type=script&lang=js&"
export * from "./NavList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/www/kunst.dk/http/public/typo3conf/ext/kunst_design/Resources/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!module.hot.data) {
      api.createRecord('6645b1b0', component.options)
    } else {
      api.reload('6645b1b0', component.options)
    }
    module.hot.accept("./NavList.vue?vue&type=template&id=6645b1b0&", function () {
      api.rerender('6645b1b0', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "Private/modernjs/nav/NavList.vue"
export default component.exports